import React from 'react'
import Accordion from '../../Accordion/Accordion'
import { CycleOrSemester } from '../utils/learningCenterUtils'

const GroupedContentSection: React.FC<{
  groupedAssets: CycleOrSemester
  isChallengeProgram: boolean
}> = ({ groupedAssets, isChallengeProgram }) => {
  const cyclesOrSemesters = Object.keys(groupedAssets)

  return (
    <>
      {cyclesOrSemesters.map((cycleOrSemester) => (
        <Accordion
          key={cycleOrSemester}
          sectionHeading={`${
            isChallengeProgram ? 'Semester' : 'Cycle'
          } ${cycleOrSemester}`}
          cycleOrSemesterNumber={+cycleOrSemester}
          accordionData={groupedAssets[cycleOrSemester]}
        />
      ))}
    </>
  )
}

export default GroupedContentSection
